module.exports = __webpack_public_path__ + "img/advantage4Red.115746b4.png";